<template>
    <div v-loading="dataLoading">
        <div style="padding: 20px 0;background-color: #fff;">
            <YellowCardWarning></YellowCardWarning>
        </div>
        <div class="content-box userCenter first">
            <div class="name">欢迎来到秀动发行{{ name }}</div>
            <div v-if="data.cpDashboardData">
                <div v-if="$store.getters.userState == 1 || verify.isVerify == 3" class="user-state">
                    您还未认证，
                    <el-button type="text"
                        @click="$contractRouter('/manage/contract/verify/fdd/step/1')">立即认证</el-button>
                </div>
                <div v-else-if="$store.getters.userState == 2" class="user-state">
                    您还未签约，
                    <el-button type="text" @click="$contractRouter($store.getters.goContractSigned)">立即签约</el-button>
                </div>
                <div v-else-if="$store.getters.userState == 4 || $store.getters.userState == 3" class="user-state">
                    全年限量100首歌曲发行？
                    <el-button type="text" @click="$router.push('/manage/pay')">购买VIP</el-button>
                </div>
                <div v-else-if="$store.getters.userState == 5 || $store.getters.userState == 6" class="user-state">
                    {{ vipEndTime }}到期
                    <template v-if="$store.state.userType != 3">
                        ，
                        <el-button type="text" @click="$router.push('/manage/pay')">立即续费</el-button>
                    </template>
                </div>
                <div class="auditAll" @click="$router.push('/manage/album/list')">
                    <div class="aboutAlbum">全部专辑</div>
                    <div class="text noborder">{{ data.cpDashboardData.albumNum || 0 }}</div>
                </div>
                <div class="auditDetail">
                    <div class="box" @click="$router.push('/manage/album/list?status=11')">
                        <div class="text">{{ data.cpDashboardData.albumAudiIngNum }}</div>
                        <div class="aboutAlbum">专辑待审核</div>
                    </div>
                    <div class="box" @click="$router.push('/manage/album/list?status=13')">
                        <div class="text">{{ data.cpDashboardData.albumAudiFailedNum }}</div>
                        <div class="aboutAlbum">专辑审核未通过</div>
                    </div>
                    <div class="box" @click="$router.push('/manage/album/list?status=10')">
                        <div class="text">{{ data.cpDashboardData.albumEditNum }}</div>
                        <div class="aboutAlbum">专辑未提交</div>
                    </div>
                    <div class="box" @click="$router.push('/manage/album/list?status=14&markStatus=0')">
                        <div class="text">{{ data.cpDashboardData.albumUpdating || 0 }}</div>
                        <div class="aboutAlbum">修改中</div>
                    </div>
                    <div class="box" @click="$router.push('/manage/album/list?status=14&markStatus=1')">
                        <div class="text noborder">{{ data.cpDashboardData.albumMarkUpdateNum || 0 }}</div>
                        <div class="aboutAlbum">修改请求</div>
                    </div>
                    <div class="box" @click="$router.push('/manage/album/list?status=12')">
                        <div class="text noborder">{{ data.cpDashboardData.albumAudiAccess || 0 }}</div>
                        <div class="aboutAlbum">审核通过</div>
                    </div>
                    <!-- <div class="box" @click="$router.push('/manage/album/list')">
                        <div class="text noborder">{{ data.cpDashboardData.albumNum || 0 }}</div>
                        <div class="aboutAlbum">全部专辑</div>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="content-box msgCenter">
            <div class="page-group-title title">{{ notice.title }}</div>
            <div class="text" v-html="notice.content"></div>
            <div v-if="!notice.title">
                <el-empty description="没有相关公告"></el-empty>
            </div>
        </div>
        <!-- <el-pagination
            background
            layout="prev, pager, next"
            :page-size.sync="params.pageSize"
            :current-page.sync="params.pageNo"
            :total="data.cpSysNoticePageData.totalCount"
            v-if="data.cpSysNoticePageData && data.cpSysNoticePageData.totalPage > 1"
            @current-change="getDataList"
        /> -->
    </div>
</template>
<script>
import YellowCardWarning from '@/components/YellowCardWarning';
export default {
    components: {
        YellowCardWarning
    },
    data() {
        return {
            data: {},
            dataLoading: true,
            params: {
                pageNo: 1,
                pageSize: 10,
            },
            notice: {
                title: '',
                content: '',
            },
        };
    },
    computed: {
        name() {
            const { userInfo } = this.$store.state;
            if (userInfo && userInfo.upgradeEnterpriseName) return `，${userInfo.upgradeEnterpriseName}`;
            if (userInfo && userInfo.cpName) return `，${userInfo.cpName}`;
            return '';
        },
        vipEndTime() {
            const { verify } = this.$store.state;
            return verify.vip ? verify.vip.endTimeStr : '';
        },
        verify() {
            return this.$store.state.verify;
        },
        userInfo() {
            return this.$store.state.userInfo;
        },
    },
    mounted() {
        this.getDataList();
        this.getNotice();
    },
    methods: {
        //获取列表数据
        getDataList() {
            this.dataLoading = true;
            this.$request({
                url: '/user/userhome/view/sysnotice_list',
                params: {},
                method: 'post',
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.data = result || {};
                    } else {
                        this.$message.error(msg || '请求失败');
                    }
                })
                .catch(() => {
                    this.$message.error('请求错误');
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        async getNotice() {
            const response = await this.$request({
                url: '/cpNotice/validAtCurTime',
                method: 'POST',
                data: {},
                formData: false,
            });
            const { msg, state, result } = response.data;
            if (!state) return this.$message.error(msg || '');
            this.notice = result;
        },
    },
};
</script>
<style lang="scss" scoped>
.userCenter {
    text-align: center;
    border-radius: 0 0 10px 10px;

    .name {
        font-size: 28px;
        font-weight: bold;
        color: $-text-950;
        line-height: 28px;
    }

    .markText {
        padding-top: 13px;
        font-size: 14px;
        font-weight: 400;
        color: $-text-950;
        line-height: 24px;

        a {
            font-weight: bold;
        }
    }

    .user-state {
        color: $-text-500;
        margin: 20px 0 0;

        .el-button {
            text-decoration: underline;
            color: $--color-base;
        }
    }

    .auditTitle {
        padding-top: 80px;
        line-height: 22px;
    }
    .auditAll {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        width: 960px;
        margin: 20px auto 0 auto;
        background: $--input-background-color;
        font-size: 20px;
        font-weight: bold;
        .aboutAlbum {
            margin-right: 10px;
        }
        .text {
            font-size: 24px;
        }
        &:hover {
            box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
            top: -6px;
        }
    }
    .auditDetail {
        padding-top: 20px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-row-gap: 30px;
        grid-column-gap: 30px;
        text-align: center;
        width: 960px;
        margin: 0 auto;

        .box {
            cursor: pointer;
            background: $--input-background-color;
            border-radius: 10px;
            height: 160px;
            padding: 60px 30px 30px;
            text-align: left;
            position: relative;
            transition: all 0.3s;
            width: 300px;

            // &:nth-child(6) {
            //     background: $--color-primary;

            //     &::after {
            //         content: '';
            //         position: absolute;
            //         background: url('~@/assets/img/cd.svg') no-repeat center;
            //         background-size: cover;
            //         width: 120px;
            //         height: 120px;
            //         bottom: 0px;
            //         right: 0px;
            //         border-radius: 0 0 10px 0;
            //     }

            //     &::before {
            //         display: none;
            //     }

            //     .aboutAlbum,
            //     .text {
            //         color: $-text-50;
            //     }
            // }

            &:hover {
                box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
                top: -6px;
            }

            &::before {
                content: '';
                background: $--color-grey;
                border-radius: 0px 0px 4px 4px;
                position: absolute;
                top: 0px;
                width: 90px;
                height: 10px;
                left: 50%;
                margin-left: -45px;
            }

            .text {
                font-size: 40px;
                font-weight: 600;
                color: $-text-950;
                line-height: 40px;
            }

            .aboutAlbum {
                font-size: 14px;
                font-weight: 400;
                color: $-text-500;
                line-height: 14px;
                margin-top: 12px;
            }
        }
    }
}

.msgCenter {
    margin-top: 20px;
    padding: 50px 150px;
    min-height: 200px;
    border-radius: 10px 10px 0 0;

    &::before {
        content: '';
        position: absolute;
        bottom: 0px;
        left: 0px;
        background: url('~@/assets/img/msg-left.png') center no-repeat;
        background-size: cover;
        width: 110px;
        height: 136px;
    }

    .page-group-title {
        font-size: 20px;
        font-weight: 400;
        color: $-text-950;
        line-height: 20px;
        margin-bottom: 20px;
    }

    .text {
        font-size: 14px;
        font-weight: 400;
        color: $-text-500 !important;
        line-height: 26px;
    }
}
</style>
